import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { loadPeriods } from '../../../redux/offers';
import { Row, Col } from '../../Grid';
import OfferList from './OfferList';

interface Props {
  loadPeriods: Function;
  periods: Array<Period>;
  business: Business;
  loaded: boolean;
}

const Item = styled.div`
  font-family: BrandonGrotesque-Regular;
  margin: 10px 0px;
  padding: 0px 20px;
  background-color: #f5f5f5;
  cursor: pointer;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  letter-spacing: normal;
  color: #333333;
`;

const Loader = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 25px;
  margin: 100px 0px;
  text-align: center;
`;

const Caret = ({ shown }: { shown: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="14"
    viewBox="0 0 9 14"
    style={{ marginTop: '17px', transform: shown ? 'rotate(90deg' : '' }}
  >
    <path
      fill="#333"
      fillRule="evenodd"
      d="M1.182 12.18L6.16 7.2 1.117 2.157A.95.95 0 0 1 2.46.813l5.702 5.7a.95.95 0 0 1 .29.684v.005a.946.946 0 0 1-.29.683v.001L2.46 13.588l-.003-.002a.95.95 0 1 1-1.276-1.407"
    />
  </svg>
);

interface Period {
  title: string;
  deals_count: string;
  period: string;
}

class OfferPeriods extends React.PureComponent<Props, {}> {
  componentDidMount() {
    if (!this.props.periods.length) this.props.loadPeriods(this.props.business.business_id);
  }

  render() {
    if (!this.props.loaded && this.props.periods.length === 0)
      return <Loader>Loading offers...</Loader>;
    if (this.props.loaded && this.props.periods.length === 0)
      return <Loader>There are no offers</Loader>;
    return (
      <div style={{ height: '95%', width: '100%', overflow: 'auto' }}>
        {this.props.periods.map((item: Period, index) => (
          <OfferPeriod period={item} key={item.period} defaultOpen={index === 0} />
        ))}
      </div>
    );
  }
}

const OfferPeriod = ({ period, defaultOpen }: { period: Period; defaultOpen: boolean }) => {
  const [open, switchOpen] = useState(defaultOpen);

  return (
    <>
      <Item onClick={() => switchOpen(!open)}>
        <Row>
          <Col size="0 0 160px">{period.title.toUpperCase()}</Col>
          <Col size="1">
            <Caret shown={open} />
          </Col>
        </Row>
      </Item>
      {open && <OfferList type="past" period={period.period} />}
    </>
  );
};

const mapStateToProps = ({ offers, business }: StoreState) => ({
  periods: offers.periods,
  loaded: offers.periodsLoaded,
  business,
});

export default connect(mapStateToProps, { loadPeriods })(OfferPeriods);
